var DAYS = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
var SORTED_DAYS = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

var formatTime = function formatTime(time) {
  if (!time) return null;
  var splitTime = time.match(/.{1,2}/g);
  return splitTime ? splitTime.join(':') : null;
};

var formatTimeInterval = function formatTimeInterval(openTime, closeTime, anotherOpenTime, anotherCloseTime) {
  if (anotherOpenTime && anotherCloseTime) {
    return "".concat(openTime, " - ").concat(closeTime, " | ").concat(anotherOpenTime, " - ").concat(anotherCloseTime);
  }

  return "".concat(openTime, " - ").concat(closeTime);
};

var formatDayPeriods = function formatDayPeriods(periods) {
  try {
    return (typeof periods === 'string' ? JSON.parse(periods.replace(/'/g, '"')) : periods).reduce(function (acc, _ref) {
      var open = _ref.open,
          close = _ref.close;
      var day = DAYS[open.day];
      var openTime = open !== null && open !== void 0 && open.time ? formatTime(open.time) : '';
      var closeTime = close !== null && close !== void 0 && close.time ? formatTime(close.time) : '';
      var anotherOpenTime = open !== null && open !== void 0 && open.anotherTime ? formatTime(open.anotherTime) : '';
      var anotherCloseTime = close !== null && close !== void 0 && close.anotherTime ? formatTime(close.anotherTime) : '';
      var timeInterval = formatTimeInterval(openTime, closeTime, anotherOpenTime, anotherCloseTime);
      if (!acc[day]) acc[day] = [];
      acc[day].push(timeInterval);
      return acc;
    }, {});
  } catch (error) {
    console.error('Error in formatting google opening hours', error);
    return {};
  }
}; // Google Places represents "open 24 hours, 7 days a week" with a single period
// that has `open.day === 0`, `open.time === '0000'` and no `close` field.
// We detect that shape explicitly, otherwise the reduce would only place a
// (malformed) entry under Sunday and every other day would render as "Closed".


var is24x7 = function is24x7(periods) {
  var _periods$, _periods$$open, _periods$2, _periods$2$open, _periods$3;

  return periods.length === 1 && ((_periods$ = periods[0]) === null || _periods$ === void 0 ? void 0 : (_periods$$open = _periods$.open) === null || _periods$$open === void 0 ? void 0 : _periods$$open.day) === 0 && ((_periods$2 = periods[0]) === null || _periods$2 === void 0 ? void 0 : (_periods$2$open = _periods$2.open) === null || _periods$2$open === void 0 ? void 0 : _periods$2$open.time) === '0000' && !((_periods$3 = periods[0]) !== null && _periods$3 !== void 0 && _periods$3.close);
};

export var formatGoogleOpeningHours = function formatGoogleOpeningHours(periods) {
  if (!(periods !== null && periods !== void 0 && periods.length)) return [];

  try {
    if (is24x7(periods)) {
      return SORTED_DAYS.map(function (day) {
        return "".concat(day, ": 00:00 - 23:59");
      });
    }

    var formattedHours = formatDayPeriods(periods);
    return SORTED_DAYS.map(function (day) {
      var _formattedHours$day;

      var intervals = ((_formattedHours$day = formattedHours[day]) === null || _formattedHours$day === void 0 ? void 0 : _formattedHours$day.join(' | ')) || 'Closed';
      return "".concat(day, ": ").concat(intervals);
    });
  } catch (error) {
    console.error('Error in formatting google opening hours', error);
    return [];
  }
};